// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2Zw3k","requiredAsterisk":"Info_requiredAsterisk__3K1X9"};